// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_oj-8";
export var editMode = "_oj-3";
export var headerRow = "_oj-a";
export var headerTitle = "_oj-b";
export var product = "_oj-1";
export var productDetails = "_oj-5";
export var productDivider = "_oj-7";
export var productImage = "_oj-2";
export var productInfo = "_oj-4";
export var productTitle = "_oj-6";
export var strikethrough = "_oj-9";
export var upsellProductsCard = "_oj-0";